import React, { useEffect, useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { CtaButton } from './CtaButton';
type FloatingCtaProps = {
  anchorId: string;
};
export function FloatingCta({
  anchorId
}: FloatingCtaProps) {
  const [visible, setVisible] = useState(false);
  useEffect(() => {
    const check = () => {
      const anchor = document.getElementById(anchorId);
      if (!anchor) return;
      setVisible(anchor.getBoundingClientRect().bottom < 0);
    };
    check();
    window.addEventListener('scroll', check, {
      passive: true
    });
    window.addEventListener('resize', check);
    return () => {
      window.removeEventListener('scroll', check);
      window.removeEventListener('resize', check);
    };
  }, [anchorId]);
  return <AnimatePresence data-id="element-30" data-mp="boybor2b829n">
      {visible && <motion.div initial={{
      y: 100,
      opacity: 0
    }} animate={{
      y: 0,
      opacity: 1
    }} exit={{
      y: 100,
      opacity: 0
    }} transition={{
      duration: 0.25,
      ease: [0.23, 1, 0.32, 1]
    }} className="fixed inset-x-0 bottom-0 z-40 border-t border-line bg-ink/95 px-3 pb-[max(12px,env(safe-area-inset-bottom))] pt-3 backdrop-blur" data-id="element-31" data-mp="19786w71u8hfb">
          <div className="mx-auto max-w-xl" data-id="element-32" data-mp="21cvvauzxdf8z">
            <CtaButton label="Get the Blueprint — $27" size="md" shake data-id="element-33" data-mp="21c4cylvc9e0n" />
          </div>
        </motion.div>}
    </AnimatePresence>;
}